import { Button } from "@/components/ui/button";
import { Phone, Calendar, Mail, ArrowRight } from "lucide-react";
import { track } from "@/lib/analytics";
import { openOpenSolar } from "@/lib/widgets";
export function CTASection() {
  return (
    <section className="py-16 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-4">Klaar voor duurzame energie?</h2>
        <p className="text-lg text-muted-foreground mb-8">
          Neem contact op voor een gratis energieadvies op maat
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg" 
            onClick={() => {
              track('cta_clicked', { section: 'general_cta' });
              window.location.href = '/offerte';
            }}
          >
            <Calendar className="mr-2 h-5 w-5" />
            Gratis Offerte
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => {
              track('contact_clicked', { method: 'phone' });
              window.location.href = 'tel:+31617105786';
            }}
          >
            <Phone className="mr-2 h-5 w-5" />
            Bel Direct
          </Button>
        </div>
      </div>
    </section>
  );
}